import React from "react";

import RenderListingSection from "sections/RenderListingSection";

/*
 * Searches in the sections array from the offer call for the correct position and
 * filters the elements for a data object.
 * @param pageSections - sections array from the offer call
 * @param position - position string top, middle or bottom
 * */

export const findAndFilterInSections = (pageSections, position) => {
  const section = pageSections.find((item) => {
    const filteredItem = item;
    if (filteredItem.position === position) {
      const filteredElements = filteredItem.elements.filter((e) => e.data);

      filteredItem.elements = filteredElements;

      return filteredItem;
    }

    return null;
  });

  return section;
};

export const TeaserSection = ({ section }) => {
  return (
    <>
      {section && (
        <RenderListingSection
          section={section}
          position="Bottom"
          spaceWrapper
        />
      )}
    </>
  );
};
